module.exports = __webpack_public_path__ + "static/media/Daily bonus button.6aee7044.svg";